import React from "react";
import _ from "lodash";
import NullMessage from "../../../../components/NullMessage";
import ObservationRatings from "../../../../components/plotly/ObservationRatings";
import ObservationsVolumeOverTime from "../../../../components/plotly/ObservationVolumeOverTime";
import { Header, Grid, Button } from "semantic-ui-react";
import { Overview, Title, RatingsGraphDetails, VolumeGraphActions } from "./style.js";
import ObservationFilters from "../ObservationFilters";

export default class ObservationsOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      volumeGrouping: "MONTHLY",
    };
    this.toggleVolumeGrouping = this.toggleVolumeGrouping.bind(this);
  }

  toggleVolumeGrouping() {
    this.setState({
      volumeGrouping: this.state.volumeGrouping === "MONTHLY" ? "DAILY" : "MONTHLY",
    });
  }

  render() {
    return (
      <Overview id="overview-tab" key="overview-tab">
        <div className="page-content">
          <ObservationFilters handleStateChange={this.handleStateChange} {...this.props} />
          {this.props.state.observations.length > 0 ? (
            <div style={{ paddingTop: "28px" }}>
              <Title>{this.props.title}</Title>
              <div style={{ position: "relative" }}>
                <RatingsGraphDetails>
                  <h3> Total observations: {this.props.state.observations.length} </h3>
                  <div>
                    {" "}
                    {this.props.observationsStart.format("MMMM D, YYYY")} -{" "}
                    {this.props.observationsEnd.format("MMMM D, YYYY")}{" "}
                  </div>
                </RatingsGraphDetails>
                <ObservationRatings
                  observations={this.props.state.observations}
                  domains={this.props.state.domains}
                  ratings={this.props.state.ratings}
                  grouping={this.props.state.grouping && this.props.state.grouping}
                  start={this.props.state.start}
                  end={this.props.state.end}
                />
                <VolumeGraphActions>
                  <Button primary onClick={this.toggleVolumeGrouping}>
                    {this.state.volumeGrouping === "MONTHLY" && "View Daily Volume"}
                    {this.state.volumeGrouping === "DAILY" && "View Monthly Volume"}
                  </Button>
                </VolumeGraphActions>
                <ObservationsVolumeOverTime
                  observations={this.props.state.observations}
                  grouping={this.state.volumeGrouping}
                  start={this.props.state.start}
                  end={this.props.state.end}
                />
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column>
                      <div className="table">
                        <Header as="h2">Observation area totals</Header>
                        <Grid columns={2}>
                          <Grid.Row className="table-header">
                            <Grid.Column textAlign="left">Observation Area</Grid.Column>
                            <Grid.Column>Count</Grid.Column>
                          </Grid.Row>
                          {_.sortBy(
                            _.toPairs(this.props.state.observationAreaCounts).map(pair => {
                              return { name: pair[0], count: pair[1] };
                            }),
                            area => {
                              return area.count * -1;
                            }
                          ).map(area => (
                            <Grid.Row key={area.name}>
                              <Grid.Column textAlign="left">
                                {area.name && area.name ? area.name : "Not Provided"}
                              </Grid.Column>
                              <Grid.Column>{area.count}</Grid.Column>
                            </Grid.Row>
                          ))}
                          <Grid.Row key="Total" className="table-footer">
                            <Grid.Column textAlign="left"> Total </Grid.Column>
                            <Grid.Column>
                              {_.reduce(this.props.state.observationAreaCounts, function(sum, count, name) {
                                return sum + count;
                              })}
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </div>
                    </Grid.Column>
                    <Grid.Column>
                      <div className="table">
                        <Header as="h2">Observer totals</Header>
                        <Grid columns={2}>
                          <Grid.Row className="table-header">
                            <Grid.Column textAlign="left">Observer Name</Grid.Column>
                            <Grid.Column>Count</Grid.Column>
                          </Grid.Row>
                          {_.sortBy(
                            _.toPairs(this.props.state.observerCounts).map(pair => {
                              return { name: pair[0], count: pair[1] };
                            }),
                            area => {
                              return area.count * -1;
                            }
                          ).map(observer => (
                            <Grid.Row key={observer.name}>
                              <Grid.Column textAlign="left">
                                {observer.name && observer.name !== "null" ? observer.name : "Not Provided"}
                              </Grid.Column>
                              <Grid.Column>{observer.count}</Grid.Column>
                            </Grid.Row>
                          ))}
                          <Grid.Row key="Total" className="table-footer">
                            <Grid.Column textAlign="left"> Total </Grid.Column>
                            <Grid.Column>
                              {_.reduce(this.props.state.observerCounts, function(sum, count, name) {
                                return sum + count;
                              })}
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          ) : (
            <NullMessage>
              {" "}
              <div style={{ paddingTop: "120px", fontWeight: "bold" }}>No Data</div>{" "}
            </NullMessage>
          )}
        </div>
      </Overview>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Observations/components/ObservationsOverview/index.jsx